import React from 'react';
import BtnPrimary from "../../../../shared/ui/button/primary/BtnPrimary";
import ModalCustom from "../../../../shared/ui/modal/ModalCustom";

const ModalDisabledEmployeeConfirm = ({confirmHandler, closeHandler, data}: any) => {
    return (
        <ModalCustom title={"Conferma disabilitazione dipendente"} closeModal={closeHandler}
                     footerTemplate={<div className={'btn-row'}>
                         <BtnPrimary onClick={closeHandler}
                                     variant={'outline-primary'}
                                     className={'text-primary'}>Annulla</BtnPrimary>
                         <BtnPrimary onClick={confirmHandler}>Conferma</BtnPrimary>
                     </div>}>
            <p>Confermi la disabilitazione del dipendente {data?.name} {data?.surname}?</p>
        </ModalCustom>
    );
};

export default ModalDisabledEmployeeConfirm;
